import { createFileRoute } from "@tanstack/react-router";

import { TrustDocumentPage } from "@/components/legal/trust-document-page";
import { multiResumeBrand } from "@/utils/multiresume-brand";

export const Route = createFileRoute("/acceptable-use-policy")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: `Acceptable Use Policy - ${multiResumeBrand.appName}` }],
  }),
});

function RouteComponent() {
  return <TrustDocumentPage documentKey="acceptableUsePolicy" />;
}
